import { h } from "@stencil/core";

export const DonutChartSlice = (props) => (
    <path
        class={`uic-donut-chart__slice uic-donut-chart__slice--${props.dataGroupKey.toLowerCase()} ${
            props.dataGroupCssClass
        }`}
        d={props.pathInterpolator(props.arcFn, props.t)}
        stroke="none"
    >
        <title>{props.tooltipText}</title>
    </path>
);
